import { Schema } from "rsuite";

const ipPattern = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;


export type CallFilters = {
    number_from: string;
    number_to: string;
    ip_src: string;
    ip_dst: string;
    // call_id: string;
    // method_code: string;
    time_from: string;
    time_to: string;
};

export const callFormModel = Schema.Model<CallFilters, string>({
    number_from: Schema.Types.StringType(),
    number_to: Schema.Types.StringType(),
    ip_src: Schema.Types.StringType().pattern(ipPattern, "Invalid IP"),
    ip_dst: Schema.Types.StringType().pattern(ipPattern, "Invalid IP"),
    // call_id: Schema.Types.StringType(),
    // method_code: Schema.Types.StringType(),
    time_from: Schema.Types.StringType(),
    time_to: Schema.Types.StringType()
});

export type DumpFilters = {
    number_from: string;
    number_to: string;
    ip_src: string;
    ip_dst: string;
    call_id: string;
    time_from: string;
    time_to: string;
};

export const dumpFormModel = Schema.Model<DumpFilters, string>({
    number_from: Schema.Types.StringType(),
    number_to: Schema.Types.StringType(),
    ip_src: Schema.Types.StringType().pattern(ipPattern, "Invalid IP"),
    ip_dst: Schema.Types.StringType().pattern(ipPattern, "Invalid IP"),
    call_id: Schema.Types.StringType(),
    time_from: Schema.Types.StringType(),
    time_to: Schema.Types.StringType()
});

export type RawPacketFilters = {
    time_from: string;
    time_to: string;
    ip_src: string;
    ip_dst: string;
    call_id: string;
    method_code: string;
};

export const rawPacketsFormModel = Schema.Model<RawPacketFilters, string>({
    time_from: Schema.Types.StringType(),
    time_to: Schema.Types.StringType(),
    ip_src: Schema.Types.StringType().pattern(ipPattern, "Invalid IP"),
    ip_dst: Schema.Types.StringType().pattern(ipPattern, "Invalid IP"),
    call_id: Schema.Types.StringType(),
    method_code: Schema.Types.StringType()
});


export type FileFilters = {
    time_from: string;
    time_to: string;
    source: string;
};

export const filesFormModel = Schema.Model<FileFilters, string>({
    time_from: Schema.Types.StringType(),
    time_to: Schema.Types.StringType(),
    source: Schema.Types.StringType()
});